import Cookies from 'js-cookie';

export const getToken = () => Cookies.get('budget_auth') || localStorage.getItem('budget_auth');

export function clearAuth() {
  localStorage.removeItem('budget_auth');
  localStorage.removeItem('budget_user');
  Cookies.remove('budget_auth', { path: '/' });
}
